import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Sparkles } from "lucide-react";

const links = [
  { href: "#over", label: "Over Seppe" },
  { href: "#shows", label: "Shows" },
  { href: "#galerij", label: "Galerij" },
  { href: "/agenda", label: "Agenda", external: false, route: true },
  { href: "#boeken", label: "Boeken" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-strong py-3" : "py-5 bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-10">
        <a href="#top" className="flex items-center gap-2 group" data-testid="nav-logo">
          <Sparkles className="w-6 h-6 text-gold group-hover:rotate-12 transition-transform duration-300" />
          <span className="font-display text-xl sm:text-2xl font-bold tracking-tight">
            Magic <span className="gold-text">Seppe</span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-8 text-sm tracking-wide text-[#B5A9C9]">
          {links.map((l) => (
            <li key={l.href}>
              {l.route ? (
                <Link
                  to={l.href}
                  className="hover:text-gold transition-colors duration-300 relative after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-px after:bg-gold hover:after:w-full after:transition-all after:duration-300"
                  data-testid={`nav-link-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  href={l.href}
                  className="hover:text-gold transition-colors duration-300 relative after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-px after:bg-gold hover:after:w-full after:transition-all after:duration-300"
                  data-testid={`nav-link-${l.href.replace('#', '')}`}
                >
                  {l.label}
                </a>
              )}
            </li>
          ))}
        </ul>

        <a
          href="#boeken"
          className="hidden md:inline-flex items-center px-5 py-2.5 rounded-full bg-gold text-night-deep font-semibold text-sm hover:bg-gold-light hover:-translate-y-0.5 transition-all duration-300 gold-glow-hover"
          data-testid="nav-cta-button"
        >
          Boek nu
        </a>

        <button
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-gold p-2"
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden glass-strong mt-3 mx-6 rounded-2xl p-6" data-testid="nav-mobile-menu">
          <ul className="flex flex-col gap-4 text-[#B5A9C9]">
            {links.map((l) => (
              <li key={l.href}>
                {l.route ? (
                  <Link
                    to={l.href}
                    onClick={() => setOpen(false)}
                    className="block py-2 hover:text-gold"
                    data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </Link>
                ) : (
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="block py-2 hover:text-gold"
                    data-testid={`nav-mobile-link-${l.href.replace('#', '')}`}
                  >
                    {l.label}
                  </a>
                )}
              </li>
            ))}
            <li>
              <a
                href="#boeken"
                onClick={() => setOpen(false)}
                className="inline-flex items-center px-5 py-2.5 rounded-full bg-gold text-night-deep font-semibold text-sm"
                data-testid="nav-mobile-cta"
              >
                Boek nu
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
